import styled from 'styled-components';

const J = {
  TotalDiv: styled.div`
      width: 80%;
      
      position: relative;
      left: 10%;
      
      font-size: 15px;
    
      border-radius: 5px;
      
      display: flex;
      justify-content: center;
      align-items: center;
  `,

  InnerTotalDiv: styled.div`
      background-color: white;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      border-radius: 20px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      width: 50%;
      margin: 60px 0;
      padding: 80px 0;
  `,

  TitleH4: styled.div`
      font-size: 28px;
      font-weight: bold;
  `,

  NoticeDiv: styled.div`
      width: 380px;
      height: 40px;

      background-color: #F3F5FF;
      color: #666666;

      border-radius: 6px;
      margin: 60px 0 40px 0;
      padding: 0 0 0 20px;

      display: flex;
      align-items: center;
  `,

  EssentialStar: styled.span`
      color: #FF6868;
      font-weight: bold;
      
      margin: 0 2px;
  `,

  IdInputLineDiv: styled.div`
      display: flex; /* 요소들을 가로로 배치 */
      align-items: center; /* 세로 정렬 */
      gap: 20px; /* 요소 간의 간격 설정 */
  `,

  IdInput: styled.input`
      width: 270px;
      height: 40px;
      
      border: 1px solid #cccccc;
      border-radius: 6px;

      font-size: 13px;

      &:focus {
          border-color: #536DFE;
          outline: none;
      }
  `,

  CheckBoxInput: styled.input`
      width: 28px;
      height: 28px;
      margin: 0 40px 0 28px;

      border: 2px solid #cccccc;
      border-radius: 50%;

      appearance: none; /* 기본 체크박스 숨김 */
      display: inline-block;
      position: relative;

      background-color: white;
      transition: all 0.2s ease;

      &:checked {
          background-color: #536dfe;
          border-color: #536dfe;
      }

      &:checked::after {
          content: '';
          position: absolute;
          top: 40%;
          left: 51.6%;
          width: 10px;
          height: 15px;
          border: solid white;
          border-width: 0 3px 3px 0;
          transform: translate(-50%, -50%) rotate(45deg);
      }

      &:hover {
          border-color: #888888;
      }
  `,

  DuplCheck: styled.button`
      width: 96px;
      height: 40px;

      background-color: #4A506B;
      color: white;

      border: 1px solid #4A506B;
      border-radius: 6px;
      cursor: pointer;
      
      font-size: 15px;

      &:hover {
          background-color: #5C617F;
      }
  `,

  CheckResultP: styled.p`
      color: #FF6868;
      font-size: 15px;
      font-weight: bold;
      
      white-space: pre-line;
      
      margin: 0;
  `,

  WarningP: styled.p`
      font-size: 13px;
      
      margin: 0;
  `,
  
  BasicDiv: styled.div` // 세로 정렬
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      
      width: 380px;
      margin-bottom: 40px;
  `,

  BasicLabel: styled.div`
      margin-bottom: 4px;
      font-weight: bolder;
  `,

  Input: styled.input`
      width: 380px;
      height: 40px;

      border: 1px solid #cccccc;
      border-radius: 6px;

      font-size: 13px;

      &:focus {
          border-color: #536DFE;
          outline: none;
      }
  `,

  EmailCheckDiv: styled.div`
      width: 380px;
      
      //background-color: red;
      border: 1px solid #cccccc;
      border-radius: 6px;
      
      margin-top: 20px;
  `,

  EmailCheckLine: styled.div`
      display: flex;
      justify-content: flex-start;
      align-items: center;
  `,

  EmailCheckInput: styled.input`
      width: 28px;
      height: 28px;

      border: 2px solid #cccccc;
      border-radius: 50%;

      appearance: none; /* 기본 체크박스 숨김 */
      display: inline-block;
      position: relative;

      background-color: white;
      transition: all 0.2s ease;

      &:checked {
          background-color: #536dfe;
          border-color: #536dfe;
      }

      &:checked::after {
          content: '';
          position: absolute;
          top: 40%;
          left: 51.6%;
          width: 10px;
          height: 15px;
          border: solid white;
          border-width: 0 3px 3px 0;
          transform: translate(-50%, -50%) rotate(45deg);
      }

      &:hover {
          border-color: #888888;
      }
  `,

  SelectSpan: styled.span`
      color: #888888;
      margin: 0 4px 0 6px;
  `,

  AboutEmailCheckP: styled.div`
      margin: 0;
      
      font-size: 13px;
      padding: 10px 4px;
  `,

  SelectOrgType: styled.select`
      width: 380px;
      height: 40px;

      border: 1px solid #cccccc;
      border-radius: 6px;

      font-size: 13px;

      &:focus {
          border-color: #536DFE;
          outline: none;
      }
  `,

  InactiveInput: styled.input`
      width: 380px;
      height: 40px;

      background-color: #cccccc;
      border: 1px solid #cccccc;
      border-radius: 6px;

      font-size: 15px;

      &:focus {
          outline: none;
      }
  `,

  SubmitBtn: styled.button`
      width: 190px;
      height: 54px;

      background-color: #536DFE;
      font-size: 15px;
      color: white;

      border: none; /* 테두리 제거 */
      border-radius: 5px; /* 모서리 둥글게 */
      cursor: pointer; /* 버튼에 마우스 올릴 때 포인터 커서 */

      margin-top: 40px;
      
      &:hover {
          background-color: #4154d0; /* 호버 시 색상 변경 */
      }
  `,
}

export default J;
